webpackJsonp([139666322020541],{

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/dinosaur.8913a96c.jpg";

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/dinosaurs-comet.9edde64d.jpg";

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _headerImage = __webpack_require__(23);
	
	var _headerImage2 = _interopRequireDefault(_headerImage);
	
	var _textImage = __webpack_require__(44);
	
	var _textImage2 = _interopRequireDefault(_textImage);
	
	var _dinosaursComet = __webpack_require__(502);
	
	var _dinosaursComet2 = _interopRequireDefault(_dinosaursComet);
	
	var _dinosaur = __webpack_require__(61);
	
	var _dinosaur2 = _interopRequireDefault(_dinosaur);
	
	var _reactHelmet = __webpack_require__(20);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Dinosaurs = function Dinosaurs() {
		return _react2.default.createElement(
			"div",
			null,
			_react2.default.createElement(
				_reactHelmet2.default,
				null,
				_react2.default.createElement(
					"title",
					null,
					"Dinosaurs Roadshow by Lee Ognibene"
				),
				_react2.default.createElement("meta", {
					name: "description",
					content: "Live and Virtual programs presented for your School or Library by teacher Lee Ognibene."
				})
			),
			_react2.default.createElement(
				"h2",
				null,
				"Dinosaurs"
			),
			_react2.default.createElement(_headerImage2.default, { src: _dinosaur2.default, alt: "Earth" }),
			_react2.default.createElement(
				"p",
				null,
				_react2.default.createElement(
					"a",
					{ href: "/static/pdf/dinosaur.pdf" },
					"Download Printable Copy"
				)
			),
			_react2.default.createElement(
				"p",
				null,
				_react2.default.createElement(
					"strong",
					null,
					"\u201CDinosaurs\u201D"
				),
				" is an exciting 40 minute video presentation that can be presented ",
				_react2.default.createElement(
					"u",
					null,
					"live"
				),
				" or ",
				_react2.default.createElement(
					"u",
					null,
					"virtual"
				),
				".\xA0 This K-6 program is very engaging and can be a springboard to many follow up activities. \xA0It\u2019s not only educational, it\u2019s very entertaining!"
			),
			_react2.default.createElement(
				"p",
				null,
				"This high definition video will show your students how fossils form and how paleontologists find dinosaur fossils to make dino skeletons.\xA0 The show reveals the secrets of how dinosaurs lived and how they suddenly became extinct 66 million years ago. \xA0This STEM program teaches many important scientific principles of biology, earth science, and environmental science."
			),
			_react2.default.createElement(
				"p",
				null,
				_react2.default.createElement(
					"strong",
					null,
					"Dinosaurs"
				),
				" was produced by Lee Ognibene, former Director of the Sayville Planetarium, and award-winning retired science teacher and videographer.\xA0 The show features amazing computer animation of dinosaurs and a music soundtrack that includes Lee\u2019s narration. \xA0",
				_react2.default.createElement(_textImage2.default, { src: _dinosaursComet2.default, alt: "Earth" })
			),
			_react2.default.createElement(
				"p",
				null,
				"It will take your students back in time to a prehistoric Earth ruled by dinosaurs.\xA0 It\u2019s not scary and many parts are actually funny!\xA0 Your students will ",
				_react2.default.createElement(
					"u",
					null,
					"love"
				),
				" this show!"
			),
			_react2.default.createElement(
				"p",
				null,
				_react2.default.createElement(
					"u",
					null,
					"If you book a ",
					_react2.default.createElement(
						"strong",
						null,
						"VIRTUAL SHOW"
					)
				),
				", I will send you a link to my streaming service and a one-day password.\xA0 Just click the link to my streaming service, put in the password and enjoy the show on your smartboard with your class.\xA0",
				" ",
				_react2.default.createElement(
					"strong",
					null,
					"Distance learning students can see it at home too!"
				)
			),
			_react2.default.createElement(
				"p",
				null,
				_react2.default.createElement(
					"strong",
					null,
					_react2.default.createElement(
						"u",
						null,
						"Price: $350 for one-day Virtual Shows for the WHOLE School!"
					)
				),
				"\xA0 Every class can stream the show on that day at all different times!\xA0 What a bargain!\xA0 If you don\u2019t have smart boards or computers in every classroom, project the show on a screen in your classroom, cafetorium or media center with a video projector and laptop computer using your schools\u2019 Wi-Fi."
			),
			_react2.default.createElement(
				"p",
				null,
				_react2.default.createElement(
					"u",
					null,
					"If you book a ",
					_react2.default.createElement(
						"strong",
						null,
						"LIVE SHOW"
					)
				),
				", I will come to your school and present a ",
				_react2.default.createElement(
					"u",
					null,
					"live"
				),
				" show using my own laptop, my bright video projector, wireless mic, and quality sound system.\xA0"
			),
			_react2.default.createElement(
				"p",
				null,
				_react2.default.createElement(
					"strong",
					null,
					_react2.default.createElement(
						"u",
						null,
						"Price: $350"
					)
				),
				_react2.default.createElement(
					"u",
					null,
					" for one live 40 minute showing"
				),
				" at your school.\xA0"
			),
			_react2.default.createElement(
				"p",
				null,
				_react2.default.createElement(
					"strong",
					null,
					"All my shows are ",
					_react2.default.createElement(
						"u",
						null,
						"accepted"
					),
					" by all 3 Long Island BOCES Arts in Education programs.\xA0",
					" "
				)
			),
			_react2.default.createElement(
				"p",
				null,
				_react2.default.createElement(
					"strong",
					null,
					"They are listed in the online BOCES Arts in Ed catalogs under \u201C",
					_react2.default.createElement(
						"u",
						null,
						"Exploratory Enrichment"
					),
					"\u201D.\xA0",
					" "
				)
			),
			_react2.default.createElement(
				"p",
				null,
				_react2.default.createElement(
					"strong",
					null,
					"To find the ",
					_react2.default.createElement(
						"u",
						null,
						"Dinosaurs"
					),
					" show, search keyword \u201CDinosaurs\u201D or \u201COgnibene\u201D to find ",
					_react2.default.createElement(
						"u",
						null,
						"all"
					),
					" my shows.\xA0",
					" "
				)
			)
		);
	};
	
	exports.default = Dinosaurs;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-dinosaurs-js-1de9908c32981b3bb21f.js